module.exports = __webpack_public_path__ + "img/04-home-what-is-gb.a8b155d0.webp";